import clsx from 'clsx'
import React from 'react'

import { PlanCardFeature, PlanCardFeatures } from './Features'
import { PlanCardGraySection } from './GraySection'
import { PlanCardPremium } from './Premium'
import { PlanCardSection } from './Section'

interface PlanCardProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'className'> {
  children: React.ReactNode;
  layout?: 'horizontal' | 'vertical';
  selected?: boolean;
  footer?: React.ReactNode;
}

export function PlanCard ({ children, layout = 'horizontal', selected, footer, ...props }: PlanCardProps) {
  return (
    <div
      {...props}
      className={clsx('group/plan-card border shadow rounded-lg transition overflow-hidden', {
        'border-gray-200': !selected,
        'border-thatch-600': selected || footer
      })}
      data-layout={layout}
      role='group'
    >
      <div className={clsx('flex items-stretch', { 'flex-col': layout === 'vertical' })}>{children}</div>
      {
        footer && (
          <div className='border-t border-thatch-600 bg-gradient-to-t from-gray-50 to-thatch-100 py-3 px-4'>
            {footer}
          </div>
        )
      }
    </div>
  )
}

PlanCard.Feature = PlanCardFeature
PlanCard.Features = PlanCardFeatures
PlanCard.Premium = PlanCardPremium
PlanCard.GraySection = PlanCardGraySection
PlanCard.Section = PlanCardSection
